import { 
    // 取得收益紀錄
    apiBizGetIncome,
    // 取得儲值帳號
    apiBizGetWalletAccount,
    // 提領
    apiBizWithdraw,
    // 取得提領紀錄
    apiBizGetWithdrawRecord,
    // 查看錢包
    apiBizGetWallet,
    // 取得全部交易紀錄
    apiBizGetAllTransRecord,
    // 取得企業銀行帳戶
    apiBizGetBankCard,
    // 企業錢包付款
    apiBizPayment
} from "@/apis/api.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_wallet_record_list: 'wallet/set_wallet_record_list',
    set_withdraw_list: 'wallet/set_withdraw_list',
    set_withdraw_filter: 'wallet/set_withdraw_filter',
    set_receive_account_list: 'wallet/set_receive_account_list',
    set_all_record_trans_list: 'wallet/set_all_record_trans_list',
    set_all_record_trans_filter: 'wallet/set_all_record_trans_filter',
    set_stored_info: 'wallet/set_stored_info',
    set_biz_balance: 'wallet/set_biz_balance',
    set_biz_total_balance: 'wallet/set_biz_total_balance',
    set_biz_total_page: 'wallet/set_biz_total_page',
    set_bank_card_list: 'wallet/set_bank_card_list',

}

// count state 必須是 Object
const state = {
    walletRecordList: [],
    withdrawList: [],
    receiveAccountList: [],
    allTransRecordList: [],
    bankCardList: [],
    storeInfo: {},
    filter: {
        withdrawRecord: {
            page: 1,
            period: ['',''],
            status: '',
        },
        allRecord: {
            // page: 1,
            period: ['',''],
            item: '',
            withdraw: ''
        }
    },
    balance: 0,
    totalBalance: 0,
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_WALLET_RECORD_LIST: (state) => {
        return state.walletRecordList
    },
    GET_BIZ_WITHDRAW_LIST: (state) => {
        return state.withdrawList
    },
    GET_BIZ_RECEIVE_ACCOUNT_LIST: (state) => {
        return state.receiveAccountList
    },
    GET_BIZ_ALL_RECORD_LIST: (state) => {
        return state.allTransRecordList
    },
    GET_BIZ_STORED_INFO: (state) => {
        return state.storeInfo
    },
    GET_BIZ_BALANCE: (state) => {
        return state.balance
    },
    GET_BIZ_TOTAL_BALANCE: (state) => {
        return state.totalBalance
    },
     GET_BIZ_WALLET_TOTAL_PAGE: (state) => {
        return state.totalPage
    },
     GET_BIZ_BANK_CARD_LIST: (state) => {
        return state.bankCardList
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizWalletRecordList({ dispatch, commit, state } ) {
        let i = state.filter.withdrawRecord.page
        if (i == 1) {
            commit(types.set_wallet_record_list);
        }
        return new Promise((resolve, reject) => {
            let data = state.filter.withdrawRecord

            apiBizGetWithdrawRecord(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_wallet_record_list, res.data.result.content);
                    if (i < res.data.result.totalPages) {
                        i++
                        dispatch('setBizWithdrawFilter', {page: i})
                        dispatch('getBizWalletRecordList')
                    } else {
                        resolve()
                    }
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    getBizWithdrawList ( {dispatch, commit, state}, data ) {
        return new Promise((resolve, reject) => {
            apiGetTransRecord(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_withdraw_list, res.data.result);
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    getBizIncome ( {dispatch, commit, state}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetIncome(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_receive_account_list, res.data.result);
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    getBizWalletAccount ( {dispatch, commit, state}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetWalletAccount(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_stored_info, res.data.result);
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    getBizGetWallet ( {dispatch, commit, state}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetWallet(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_biz_balance, res.data.result.balance);
                    commit(types.set_biz_total_balance, res.data.result.totalBalance);
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    getBankCardList ( {commit} ) {
        return new Promise((resolve, reject) => {
            apiBizGetBankCard()
            .then(res => {
                console.log(res)
                if(res.data.status == "SUCCESS"){
                    commit(types.set_bank_card_list, res.data.result)
                    resolve()
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    getBizGetAllTransRecord({ dispatch, commit, state } ) {
        // let i = state.filter.allRecord.page
        // if (i == 1) {
        //     commit(types.set_all_record_trans_list);
        // }
        return new Promise((resolve, reject) => {
            let data = state.filter.allRecord

            apiBizGetAllTransRecord(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_all_record_trans_list, res.data.result);
                    // commit(types.set_biz_total_page, res.data.result.totalPage);
                    // dispatch('getBizGetAllTransRecord')
                    resolve()

                    // if (i < res.data.result.totalPages) {
                    //     i++
                    //     dispatch('setBizAllRecordFilter', {page: i})
                    //     dispatch('getBizGetAllTransRecord')
                    // } else {
                    //     resolve()
                    // }
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    bizWithdrawWallet ( {dispatch, commit, state}, data ) {
        return new Promise((resolve, reject) => {
            apiBizWithdraw(data)
            .then(res => {
                console.log(res)
                if (res.data.status == "SUCCESS") {
                    dispatch('getBizGetWallet')
                    dispatch('getBizWalletRecordList')
                    dispatch('setAlarmStatus', {status: true,title: '提領審核中',type: 'success'})
                    resolve()
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    setBizWithdrawFilter ( {dispatch, commit, state}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_withdraw_filter, data)
            resolve()
        })
    },
    setBizAllRecordFilter ( {dispatch, commit, state}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_all_record_trans_filter, data)
            resolve()
        })
    },
    bizWalletPayment ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            apiBizPayment(data)
            .then(res => {
                console.log(res)
                if(res.data.status == "SUCCESS"){
                    resolve(res.data.result)
                }else{
                    reject()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },

}
// mutations
const mutations = {
    // count state 必須是 Object
    [types.set_wallet_record_list](state, data) {
        if(data){
            data.map( item => {
                state.walletRecordList.push(item) 
            })
        }else{
            state.walletRecordList = []
        }
    },
    [types.set_withdraw_list](state, data){
        state.withdrawList = data
    },
    [types.set_withdraw_filter](state, data) {
        for (let keyName in data) {
            state.filter.withdrawRecord[keyName] = data[keyName]
        }
    },
    [types.set_receive_account_list](state, data){
        state.receiveAccountList = data
    },
    [types.set_all_record_trans_list](state, data) {
        state.allTransRecordList = data
        // if(data){
        //     data.map( item => {
        //         state.allTransRecordList.push(item) 
        //     })
        // }else{
        //     state.allTransRecordList = []
        // }
    },
    [types.set_all_record_trans_filter](state, data) {
        for (let keyName in data) {
            state.filter.allRecord[keyName] = data[keyName]
        }
    },
    [types.set_bank_card_list](state, data){
        state.bankCardList = data
    },
    [types.set_biz_total_page](state, data){
        state.totalPage = data
    },
    [types.set_stored_info](state, data){
        state.storeInfo = data
    },
    [types.set_biz_balance](state, data){
        state.balance = data
    },
    [types.set_biz_total_balance](state, data){
        state.totalBalance = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/settingCenter/wallet/wallet.js